import styled from 'styled-components';

export const SelectedToolsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  width: 100%;
  flex: 1;
  max-height: 600px;
  overflow-y: auto;
  padding-right: 8px;
  
  /* Responsive behavior */
  @media (max-width: 1024px) {
    max-height: none;
    flex: 1;
  }
  
  @media (max-width: 768px) {
    max-height: 400px;
    flex: 0 0 auto;
  }
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.veryLightGray || '#f0f0f0'};
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.silverSand || '#c4c4c4'};
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.colors.philippineSilver || '#a0a0a0'};
  }
`;

